export default __webpack_public_path__ + "c1de401880307a39a87e7b4668f32a3d.png";